import { render, staticRenderFns } from "./AlterarPropriaSenha.vue?vue&type=template&id=2641f8e7"
import script from "./AlterarPropriaSenha.vue?vue&type=script&lang=ts"
export * from "./AlterarPropriaSenha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports